import Form from '@utils/form/index'
import { status, barType } from './config/index'
import tableSelect from './config/tableSelect'
import Select from '@utils/common/select'
const select = Select.use('/sysOffice/getSysOfficeByParams').params({ useable: '0', officeType: '1' }).value('id')
import { addSrmBarRuleHead } from '@api/barcode/index'

async function submit(this: any, data: any) {
  await addSrmBarRuleHead({ ...data, detailList: data.detailList.map((item: object, index: number) => ({ ...item, partNo: index })) })
}

export default new Form('barcode.rule')
  .url(submit)
  .title('formTitle.baseInfo')
  .add('officeId').select(select).required()
  .add('barRuleNo').required()
  .add('barRuleName').required()
  .add('barType').op(barType).required()
  .add('status').op(status).default(1).required()
  .lib('remarks')
  .table('detailList', tableSelect)
  .end()
